import React, { createContext, useContext, useRef, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const PrevLocationContext = createContext(null);

export function PreviousLocationProvider({ children }) {
    const location = useLocation();
    const prevRef = useRef(null);

    useEffect(() => {
        prevRef.current = location;
    }, [location]);

    return (
        <PrevLocationContext.Provider value={prevRef.current}>
            {children}
        </PrevLocationContext.Provider>
    );
}

export function usePreviousLocation() {
    return useContext(PrevLocationContext);
};